import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ProvinceDTO} from '../../../shared/dto/province.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceService} from '../../../shared/service/province.service';
import {DistrictService} from '../../../shared/service/district.service';
import {DistrictDTO} from '../../../shared/dto/district.model';
import swal from "sweetalert2";
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {DistrictPopupComponent} from './district-popup/district-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-district',
  templateUrl: './district.component.html',
  styleUrls: ['./district.component.scss']
})
export class DistrictComponent implements OnInit {
  public districtForm: FormGroup;
  public provinceModel: ProvinceDTO[] = [];
  public districtModel: DistrictDTO[] = [];
  public districtConfigItem: DistrictDTO[] = [];
  public href: string = "";
  constructor(public modalService: NgbModal,
              public provinceService: ProvinceService,
              public districtService: DistrictService,
              public tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.districtForm = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
      province: new FormControl(null),
    });
    this.href = this.router.url;
    this.loadProvinces();
    this.loadDistricts();
    this.onLoadGetData();
  }

  loadProvinces() {
    this.provinceService.getAllProvinces().subscribe(
      (data: ProvinceDTO[]) => {
        this.provinceModel = data;
      }
    );
  }

  loadDistricts() {
    this.districtService.getAllDistricts().subscribe(
      (data: DistrictDTO[]) => {
        this.districtModel = data;
        this.districtConfigItem = data;
      }
    );
  }

  onLoadGetData(): void {
      const districtDTO = new DistrictDTO(
      null,
      null,
      null,
      null,
        null,
        null
    );
    this.loadSearchResultList(districtDTO);
  }

  loadSearchResultList(districtDTO: DistrictDTO): void {
    this.districtService.searchDistrictDetails(districtDTO).subscribe(
      (data: DistrictDTO[]) => {
        this.districtConfigItem = data;
      },
      (error) => {
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        if (this.districtConfigItem == null || this.districtConfigItem.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadDistricts();
        } else {
          this.districtService.clearProvinceSearchDetails();
          this.districtService.setProvinceSearchDetails(
            this.districtConfigItem
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.districtForm.value.code != null) {
      isValid = true;
    }
    if (this.districtForm.value.description != null) {
      isValid = true;
    }
    if (this.districtForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.districtForm.valid) {
      const districtDTO = new DistrictDTO(
        this.districtForm.value.code,
        this.districtForm.value.description,
        this.districtForm.value.states,
        this.districtForm.value.province,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(districtDTO);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset(){
    this.districtForm.reset({
      code: null,
      description: null,
      states: null,
      province: null,
    });
    this.onLoadGetData();
  }

  onClickNew(){
    const modalRef = this.modalService.open(DistrictPopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.districtMgtCopy_ = this.districtConfigItem;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadDistricts();
        this.loadProvinces();
      }
    }, () => {

    });
  }
}
